import { SearchParamsOption } from 'ky';

import { IGetBatches } from '../types/api';
import { IBatch } from '../types/batch';

export const serializeGetBatchesParams = ({
  name,
  group,
  startDate,
  endDate,
  page = 1,
  pageSize = 20,
  pagination = true,
  includeFermentations = false,
  ...params
}: IGetBatches): SearchParamsOption => {
  const searchQuery = [
    ['page', page],
    ['page_size', pageSize],
  ];
  const states = params.states?.join(',');
  const methods = params.methods?.join(',');
  if (states) searchQuery.push(['states', states]);
  if (methods) searchQuery.push(['methods', methods]);
  if (name) searchQuery.push(['name', name]);
  if (group) searchQuery.push(['group', group]);
  if (startDate) searchQuery.push(['st_date_creation', startDate.toString()]);
  if (endDate) searchQuery.push(['end_date_creation', endDate.toString()]);
  if (pagination) searchQuery.push(['pagination', 'true']);
  if (includeFermentations) searchQuery.push(['include_fermentation', 'true']);

  return searchQuery;
};

export const serializeCreateBatchesParams = ({
  tags,
  appVersion,
  description,
  scaleType,
  resultStat,
  imageVolume,
  fermentedAt,
  dilutionSample,
  dilutionSample1,
  dilutionSample2,
  dilutionStain,
  dilutionStain1,
  dilutionStain2,
  methodAttributes,
  locallyCreatedAt,
  userCorrectionEnabled,
  ...rest
}: Partial<IBatch>) => {
  const data: any = {
    ...rest,
    desc: description,
    scale_type: scaleType,
    app_version: appVersion,
    result_stat: resultStat,
    image_volume: imageVolume,
    fermented_at: fermentedAt,
    dilution_sample: dilutionSample,
    dilution_sample_1: dilutionSample1,
    dilution_sample_2: dilutionSample2,
    dilution_stain: dilutionStain,
    dilution_stain_1: dilutionStain1,
    dilution_stain_2: dilutionStain2,
    created_locally_at: locallyCreatedAt,
    user_correction_enabled: userCorrectionEnabled,
    tags: JSON.stringify(tags),
    method_attributes: JSON.stringify({
      stain: methodAttributes?.stain,
      analysis_level: methodAttributes?.analysisLevel,
    }),
  };

  return data;
};
